import { Navigate, Outlet } from 'react-router-dom';

export const RequireAuthToHidden = () => {
	const pxcUser = localStorage.getItem('pxcUser') || '';
	if (pxcUser) return <Navigate to='/' />;

	return <Outlet />;
};
